import { connect } from 'react-redux'
import labelSelector from './labelSelector'
import requestRemoveLabel from '../../../sagas/requestRemoveLabel'
import Label from './Label'
import { withBoardContext } from 'dataProviders/Board'

export default withBoardContext(connect(
  labelSelector,
  {
    requestRemoveLabel
  },
  null,
  {
    forwardRef: true
  }
)(Label))
